/**
 * Returns whether an operation has at least one price value loaded.
 *
 * Brazilian companies use a single `price` field; multi-currency companies
 * store values in the `prices` map keyed by currency code.
 *
 * @param {Object} operation - Sale or rent operation from Redux pricing state
 * @param {boolean} isBrazilianCompany
 * @returns {boolean}
 */
export function operationHasPrice(operation, isBrazilianCompany = true) {
  if (!operation) return false;

  if (isBrazilianCompany) {
    return parseFloat(operation.price) > 0;
  }

  return Object.values(operation.prices ?? {}).some(
    (value) => parseFloat(value) > 0
  );
}

/**
 * Returns whether short-term rental has at least one period selected with a
 * price value greater than zero.
 *
 * @param {Object} shortTermRental - Short-term rental state from Redux
 * @returns {boolean}
 */
export function shortTermRentalHasPeriodWithPrice(shortTermRental) {
  const periods = Array.isArray(shortTermRental?.periods)
    ? shortTermRental.periods
    : [];

  return periods.some((item) => item?.period && parseFloat(item.price) > 0);
}

export function getOperationToggleLabelKey(
  canEnable,
  enabled,
  disabledLabelKey = 'PricingStep.EnterPriceToEnable'
) {
  if (!canEnable) return disabledLabelKey;
  if (!enabled) return 'Enable';
  return 'Enabled';
}
